'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-dom-server.node.production.min.js');
} else {
  module.exports = require('./cjs/react-dom-server.node.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/_react-dom@16.2.0@react-dom/server.node.js
// module id = 46
// module chunks = 0